import React from 'react'
import PropTypes from 'prop-types'

import BasicViewComponent from './BasicViewComponent'
import View from './View'

class CompositeHorizontal extends BasicViewComponent {

  constructor (props) {
    super(props)

    this.contents = this.props.config.contents
    this.keyPrefix = Math.random().toString(36).substr(2, 5)
  }

  render () {
    if (!super.conditionsAreMet()) {
      return null
    }

    const views = this.contents.map((view, index) => {
      return (
        <View
          key={`${this.keyPrefix}-${index}`}
          config={view}
          functions={this.props.functions}
          poi={this.props.poi}
          filterSettings={this.props.filterSettings}
          setCategoryVisible={this.props.setCategoryVisible}
          setSelectedCountry={this.props.setSelectedCountry}
        />
      )
    })

    return (
      <span className={this.cssClass}>
        {views}
      </span>
    )
  }
}

CompositeHorizontal.TYPE = 'composite_horizontal'

CompositeHorizontal.propTypes = {
  config: PropTypes.object.isRequired,
  functions: PropTypes.object,
  poi: PropTypes.object,
  filterSettings: PropTypes.object,
  setCategoryVisible: PropTypes.func,
  setSelectedCountry: PropTypes.func
}

export default CompositeHorizontal



// WEBPACK FOOTER //
// ./src/components/ViewComponents/CompositeHorizontal.js